import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledLinkedinCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.page_background};
  height: 50px;
  border-radius: ${theme.variables.border_radius_1};
  padding: 0 12px;

  & .linkedin-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;
